var path = 'pages/acceptInvite.html';
var html = "<h1>Accept Invite Request</h1> <div> <input type=text data-ng-model=code> <savebutton data-state=acceptInviteState data-ng-click=accept()></savebutton> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/pages/acceptInvite.html
// module id = 1L/J
// module chunks = 1